import {createContext} from "react";

export type ProductConfigurationContextType = {
    cartProductId: number | undefined;
};

export const ProductConfigurationContext = createContext<ProductConfigurationContextType | null>(null);